var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpperR(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 311,
    viewBox: "0 0 184 311",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9582 170.2C79.9582 163.9 130.358 151.9 152.558 122.5C161.858 109.6 165.458 94.6 163.358 77.8C160.058 56.5 149.558 40 133.058 29.5C87.7582 0.399978 9.1582 23.2 5.8582 24.1L0.158203 26.2V310.6H16.0582V171.1L160.358 310.6H183.458L37.9582 170.2ZM16.0582 157.3V38.2C28.9582 34.6 90.1582 20.8 124.658 42.7C137.558 50.8 144.758 63.1 147.458 80.2C149.558 93.1 147.158 103.3 139.658 112.9C119.558 139.6 68.2582 149.8 19.9582 156.7L16.0582 157.3Z",
    fill: "#FEC736"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperR);
export default __webpack_public_path__ + "static/media/UPPER_R.3ff4d3a4247e14cd0fe1e1431be4ad2c.svg";
export { ForwardRef as ReactComponent };